import { CSSProperties } from "react";

type Props = {
  alignItems?: CSSProperties["alignItems"];
  children: any;
  gap?: number;
  flexDirection?: CSSProperties["flexDirection"];
  justifyContent?: CSSProperties["justifyContent"];
};

export function FlexBox({
  alignItems,
  children,
  flexDirection = "row",
  gap = 0,
  justifyContent,
}: Props) {
  return (
    <div
      style={{
        alignItems,
        display: "flex",
        flexDirection,
        gap,
        justifyContent,
      }}
    >
      {children}
    </div>
  );
}
